<template>
  <div class="table-responsive">
    <p>
      Segue abaixo a exibição do histórico de logs de faturas enviadas para a omie.
    </p>
    <div class="d-flex justify-content-between align-items-center mb-3">
      <div class="form-inline">
        <label class="mr-2"><strong>Filtrar por:</strong></label>
        <select class="form-control" v-model="status" @change="onFilterChange">
          <option value="2">Erros</option>
          <option value="1">Sucesso</option>
          <option value="all">Todos</option>
        </select>
      </div>
      <button
        v-if="omieAlerts.invoice > 0"
        class="btn btn-sm btn-outline-brand"
        @click="markAsSeen()"
      >
        <i class="fas fa-check"></i> Marcar alertas como vistos ({{ omieAlerts.invoice }})
      </button>
    </div>
    <div class="container-table mt-3">
      <table class="table table-bordered">
        <thead>
          <tr>
            <th nowrap class="text-center">Enviado Por</th>
            <th nowrap class="text-center">ID Fatura</th>
            <th nowrap class="text-center">ID Cliente</th>

            <th nowrap class="text-center">Produto</th>

            <th nowrap class="text-center">Mês Fatura</th>
            <th nowrap class="text-center">Log</th>
            <th nowrap class="text-center">Data</th>
          </tr>
        </thead>
        <tbody>
          <template v-for="(audit, index) in data.data">
            <tr
              data-toggle="collapse"
              :data-target="'#fields' + index"
              class="clickable pointer"
              :key="index"
            >
              <td class="text-center">{{ audit.username }}</td>
              <td class="text-center">{{ audit.id }}</td>
              <td class="text-center">{{ audit.customer_id }}</td>
              <td class="text-center">{{ audit.name }}</td>
              <td class="text-center">{{ audit.billing_month | date }}</td>
              <td class="text-center">{{ audit.log }}</td>
              <td class="text-center">{{ audit.created_at | datetimeUtcToBr }}</td>
            </tr>
            <tr :key="'detail' + index" class="detail-row">
              <td :colspan="7" class="p-0">
                <div :id="'fields' + index" class="collapse">
                  <div class="p-3 text-left detail-box">
                    <p>
                      <strong>Cliente:</strong>
                      {{
                        audit.customer && audit.customer.customerable
                          ? audit.customer.customerable.co_name
                          : '-'
                      }}
                    </p>
                    <p>
                      <strong>Documento:</strong>
                      {{
                        audit.customer && audit.customer.documents
                          ? audit.customer.documents.value
                          : '-'
                      }}
                    </p>
                    <p><strong>Rota (Omie):</strong> {{ audit.call || '-' }}</p>
                    <p class="mb-1"><strong>Mensagem de erro:</strong></p>
                    <pre class="detail-pre">{{ audit.log || 'Não disponível' }}</pre>
                    <p class="mb-1 mt-2"><strong>Body enviado na requisição:</strong></p>
                    <pre class="detail-pre">{{ formatBody(audit.request_body) }}</pre>
                  </div>
                </div>
              </td>
            </tr>
          </template>
        </tbody>
      </table>
    </div>
    <PaginatorBottom
      :from="data.from"
      :to="data.to"
      :total="data.total"
      :current_page="data.current_page"
      :last_page="data.last_page"
      @setPage="setPage"
    />
  </div>
</template>

<script>
import { returnMessageFormMixin } from '@/mixins/returnMessageFormMixin';
import { omieAlertsMixin } from '@/mixins/omieAlertsMixin';
import { baseApiUrl } from '@/global';
import PaginatorBottom from '@/components/template/paginator/Bottom.vue';
import axios from 'axios';

export default {
  mixins: [returnMessageFormMixin, omieAlertsMixin],
  name: 'OmieSendInvoiceLogHistory',
  components: { PaginatorBottom },
  data() {
    return {
      data: {},
      page: 1,
      status: '2',
    };
  },
  methods: {
    getDatas() {
      const url = `${baseApiUrl}/v1/audits/omie-invoice-send-log?page=${this.page}&status=${this.status}`;
      axios(url).then((res) => {
        this.data = res.data;
      });
    },
    setPage(page) {
      this.page = page;
      this.getDatas();
    },
    onFilterChange() {
      this.page = 1;
      this.getDatas();
    },
    markAsSeen() {
      this.markOmieLogsSeen('invoice');
    },
    formatBody(body) {
      if (!body) return 'Não disponível';
      try {
        return JSON.stringify(JSON.parse(body), null, 2);
      } catch (e) {
        return body;
      }
    },
  },
  beforeMount() {
    this.getDatas();
  },
  computed: {},
};
</script>

<style scoped>
.detail-box {
  background-color: #f7f7f9;
}
.detail-pre {
  white-space: pre-wrap;
  word-break: break-all;
  max-height: 300px;
  overflow: auto;
  background-color: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  padding: 10px;
  font-size: 12px;
  margin: 0;
}
</style>
